import React from "react";
import Skeleton from "react-loading-skeleton";

export default function TableSkeleton({ tableHeader, children }) {
  return (
    <div className="table-blk table-responsive">
      <table className="table border-0 mb-0">
        <thead>
          <tr>
            {tableHeader.map((item) => (
              <th>
                <Skeleton className="form-control" height={30} width={150} />
              </th>
            ))}
          </tr>
        </thead>
        <tbody>{children}</tbody>
      </table>
    </div>
  );
}
